import { closeSnackbar, enqueueSnackbar } from 'notistack'
import { useEffect } from 'react'
import ReCAPTCHA from "react-google-recaptcha"
import { KEY } from '../Common/constant'
import { useRecaptcha } from '../Common/Hook/useRecaptcha'

const Recaptcha = () => {
    const { recaptchaToken, onHandleRecaptchaToken } = useRecaptcha()
    const siteKey = KEY.RECAPTCHA_SITE

    useEffect(() => {
        if (!recaptchaToken) {
            enqueueSnackbar({
                message: "Please complete the reCAPTCHA",
                variant: "warning",
                persist: true
            })
        } else {
            closeSnackbar()
        }
    }, [recaptchaToken])

    return (
        <ReCAPTCHA
            sitekey={siteKey}
            onChange={onHandleRecaptchaToken}
        />
    )
}

export default Recaptcha